<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_1"></a>Contents</h2>
<p class="toca"><a href="#/xhtml/fm01"><em>Author’s foreword</em></a></p>
<div class="lb-db">
<p class="toc1"><a href="#/xhtml/chapter01"><strong>GETTING STARTED</strong></a></p>
<p class="toc"><a href="#/xhtml/chapter01#sec1">Small but refined</a></p>
<p class="toc"><a href="#/xhtml/chapter01#sec2">Types of small gardens</a></p>
<p class="toc"><a href="#/xhtml/chapter01#sec3">Range of plants for small gardens</a></p>
<p class="toc"><a href="#/xhtml/chapter01#sec4">Choice of infrastructure</a></p>
<p class="toc"><a href="#/xhtml/chapter01#sec5">Problems and opportunities</a></p>
<p class="toc"><a href="#/xhtml/chapter01#sec6">Design and planning</a></p>
<p class="toc"><a href="#/xhtml/chapter01#sec7">Getting equipped</a></p>
<p class="toc"><a href="#/xhtml/chapter01#sec8">Lighting in a garden</a></p>
<p class="toc"><a href="#/xhtml/chapter01#sec9">Choosing and buying plants</a></p>
<p class="toc"><a href="#/xhtml/chapter01#sec10">Looking after plants</a></p>
<p class="toc"><a href="#/xhtml/chapter01#sec11">Flower gardens</a></p>
</div>
<div class="org-dorg">
<p class="toc1"><span href="#/xhtml/chapter02" title="Link target outside of Sample">CHOOSING THE STYLE</span></p>
<p class="toc"><span href="#/xhtml/chapter02#sec12" title="Link target outside of Sample">Informal gardens</span></p>
<p class="toc"><span href="#/xhtml/chapter02#sec13" title="Link target outside of Sample">Formal gardens</span></p>
<p class="toc"><span href="#/xhtml/chapter02#sec14" title="Link target outside of Sample">Mediterranean influences</span></p>
<p class="toc"><span href="#/xhtml/chapter02#sec15" title="Link target outside of Sample">Japanese influences</span></p>
<p class="toc"><span href="#/xhtml/chapter02#sec16" title="Link target outside of Sample">Container gardening</span></p>
<p class="toc"><span href="#/xhtml/chapter02#sec17" title="Link target outside of Sample">Wild gardens</span></p>
<p class="toc"><span href="#/xhtml/chapter02#sec18" title="Link target outside of Sample">Balcony and roof gardening</span></p>
<p class="toc"><span href="#/xhtml/chapter02#sec19" title="Link target outside of Sample">Creating a secluded garden</span></p>
<p class="toc"><span href="#/xhtml/chapter02#sec20" title="Link target outside of Sample">Low-maintenance gardens</span></p>
<p class="toc"><span href="#/xhtml/chapter02#sec21" title="Link target outside of Sample">Food-producing gardens</span></p>
</div>
<div class="gr-dgr">
<p class="toc1"><span href="#/xhtml/chapter03" title="Link target outside of Sample">PLANTS FOR SMALL GARDENS</span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec22" title="Link target outside of Sample">Summer-flowering annuals</span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec23" title="Link target outside of Sample">Spring-flowering bedding plants</span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec24" title="Link target outside of Sample">Herbaceous perennials</span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec25" title="Link target outside of Sample">Shrubs and small trees</span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec26" title="Link target outside of Sample">Wall shrubs</span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec27" title="Link target outside of Sample">Climbers</span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec28" title="Link target outside of Sample">Rock-garden plants</span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec29" title="Link target outside of Sample">Water and marginal plants</span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec30" title="Link target outside of Sample">Bamboos</span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec31" title="Link target outside of Sample">Ornamental grasses</span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec32" title="Link target outside of Sample">Plants for containers</span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec33" title="Link target outside of Sample">Small conifers</span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec34" title="Link target outside of Sample">Culinary herbs</span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec35" title="Link target outside of Sample">Fruit: soft and top</span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec36" title="Link target outside of Sample">Vegetables</span></p>
</div>
<div class="vio-dvio">
<p class="toc1"><span href="#/xhtml/chapter04" title="Link target outside of Sample">GARDEN CONSTRUCTION</span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec37" title="Link target outside of Sample">Choosing a path</span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec38" title="Link target outside of Sample">Path construction</span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec39" title="Link target outside of Sample">Making a patio</span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec40" title="Link target outside of Sample">Choosing a fence</span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec41" title="Link target outside of Sample">Choosing a wall</span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec42" title="Link target outside of Sample">Garden steps</span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec43" title="Link target outside of Sample">Decking</span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec44" title="Link target outside of Sample">Terraces and verandas</span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec45" title="Link target outside of Sample">Patios and courtyards</span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec46" title="Link target outside of Sample">Pergolas and trellises</span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec47" title="Link target outside of Sample">Arches and arbors</span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec48" title="Link target outside of Sample">Porches and entrances</span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec49" title="Link target outside of Sample">Edgings for borders and paths</span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec50" title="Link target outside of Sample">Sheds and summerhouses</span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec51" title="Link target outside of Sample">Greenhouses and cloches</span></p>
</div>
<p class="toca"><span href="#/xhtml/bm01" title="Link target outside of Sample"><em>Glossary</em></span></p>
<p class="toca"><span href="#/xhtml/bm02" title="Link target outside of Sample"><em>Index</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?129d74f2